import {
    Bar,
    BarChart,
    CartesianGrid, Cell,
    Legend,
    Line,
    LineChart,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis
} from "recharts";
import React from "react";
import { dayOfWeekPattern } from "../attendance.types";
import LoadingSkeleton from "../../common/loading-skeleton/loading-skeleton";

interface IProps {
    data: dayOfWeekPattern[];
    isLoading: boolean;
}

const WeeklyTrendChart = (props: IProps) => {


    return (
        <section className="pn-attendance__card bar-chart-wrapper">
            <div className="pn-attendance__card__header">
                <h3 className="pn-attendance__card__title">Day-of-Week Pattern</h3>
                <span className="pn-attendance__card__subtitle">Average attendance % by weekday  (last 3 months)</span>
            </div>
            <LoadingSkeleton loading={props.isLoading}>
                <ResponsiveContainer width="100%" height={240}>
                    <BarChart
                        margin={{top: 4, right: 8, bottom: 0}}
                        barSize={40}
                        barGap={1}
                        data={props.data}>
                        <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" vertical={false}/>

                        <XAxis
                            dataKey="day"
                            tick={{
                                fontSize: 12,
                                fill: 'var(--pn-text-secondary)'
                            }}
                        />

                        <YAxis
                            domain={[0, 100]}
                            unit="%"
                            tick={{
                                fontSize: 12,
                                fill: 'var(--pn-text-secondary)'
                            }}
                        />

                        <Tooltip
                            contentStyle={{
                                backgroundColor: 'var(--pn-bg-card)',
                                border: '1px solid var(--pn-border)',
                                borderRadius: '8px',
                                padding: '8px',
                                fontSize: '12px',
                                color: 'var(--pn-text-primary)'
                            }}
                        />


                        <Bar
                            dataKey="attendanceRate"
                            name="Attendance Rate"
                            fill="var(--info-hover)"
                            radius={[4, 4, 0, 0]}
                        >
                            {props.data.map((entry, index) => (
                                <Cell
                                    key={index}
                                    fill={
                                        entry.attendanceRate >= 90
                                            ? "var(--success-hover)"
                                            : entry.attendanceRate >= 75
                                            ? "var(--warning-hover)"
                                            : "var(--danger-hover)"
                                    }
                                />
                            ))}
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            </LoadingSkeleton>

        </section>
    )
}

export default WeeklyTrendChart;
